import * as React from 'react';
import { MetricView } from 'cb-model';
import { List, PageTitle, QueryMulti, Section } from 'gossamer-front-end';

export const MetricsDisplay = (): React.JSX.Element => {
  return (
    <>
      <PageTitle title="Metrics" subtitle="Key business measures" />
      <Section>
        <QueryMulti entity={MetricView} render={List} />
      </Section>
    </>
  );
};
